import { IndexedCache } from './indexedcache';
import { normalizePath } from '../util/path';

export class DataCache {
    _cache: any;

    constructor(loader: any) {
      this._cache = new IndexedCache(loader.load);
    }

    get(path: any, callback: any) {
      const normPath = normalizePath(path);
      this._cache.get(normPath, callback);
    }

}

/**
 * An IndexedCache variant intended for use with a loader and file paths.
 * Automatically handles normalizing the path as much as possible to ensure
 * alternate references to the same file still uses the cache.
 *
 * @constructor
 * @param {Loader} loader
 * The loader to use with this DataCache.
 */


/**
 * Retrieves a single file from the cache, loading it if it has not
 * already been loaded.
 *
 * @param {string} path
 * The file to retrieve from the cache.
 * @param {Function} [callback]
 */


